import { BFFClient } from "./client";
import { REACT_MESSAGE, SEND_MESSAGE } from "../utils/urls";

export interface ChatPostBody {
  chatId?: string;
  prompt: string;
}

export interface ReactMessageBody {
  messageId: string;
  reaction: string;
}

export interface ChatPostResponse {
  answer: string;
  chat_id: string;
  agent_name?: string;
  chat_message_id?: string;
}

async function sendMessage(
  token: string,
  payload: ChatPostBody
): Promise<ChatPostResponse> {
  const ticket = await BFFClient(token).post(SEND_MESSAGE, payload);

  return ticket.data;
}

async function reactMessage(
  token: string,
  payload: ReactMessageBody
): Promise<{ status: string; message: string }> {
  const ticket = await BFFClient(token).post(REACT_MESSAGE, payload);

  return ticket.data;
}

export const agentsService = {
  sendMessage,
  reactMessage,
};
